import { ReactElement } from 'react';
import { useOutletContext } from 'react-router-dom';
import Skeleton from '../../../components/Skeleton';
import RunMap from './RunMap';
import BodyHistogram from './BodyHistogram';
import YawHistogram from './YawHistogram';
import TyrePressureSummary from './TyrePressureSummary';
import RunNotes from './RunNotes';

interface RunDetailsContext {
  run?: any;
  isRunsPending: boolean;
  calibration: any;
}

export default function RunDetails(): ReactElement {
  const { run, isRunsPending, calibration } = useOutletContext<RunDetailsContext>();

  return (
    <Skeleton isPending={isRunsPending}>
      {run && (
        <div className="cr-flex cr-flex-col cr-gap-8">
          <RunNotes run={run} />
          <RunMap
            lats={run.data_gridded?.GpsLat_AG20}
            lons={run.data_gridded?.GpsLon_AG20}
            gates_lat={run.run_health_obj?.sensors_present?.gates?.gates_lat}
            gates_lon={run.run_health_obj?.sensors_present?.gates?.gates_lon}
          />
          <TyrePressureSummary run={run} />
          <YawHistogram run={run} calibration={calibration} />
          <BodyHistogram run={run} calibration={calibration} />
        </div>
      )}
    </Skeleton>
  );
}
